import { onUnmounted, ref } from 'vue';
const DEFAULT_HOVERING_ID = '$_id_$';
function useHovering(deplay = 100) {
    const isHoveringData = ref({});
    let isHoveringHanlder = {};
    const enter = (id = DEFAULT_HOVERING_ID) => {
        isHoveringHanlder[id] && window.clearTimeout(isHoveringHanlder[id]);
        isHoveringData.value[id] = true;
    };
    const leave = (id = DEFAULT_HOVERING_ID) => {
        isHoveringHanlder[id] = window.setTimeout(() => {
            isHoveringData.value[id] = false;
        }, deplay);
    };
    const isHovering = (id = DEFAULT_HOVERING_ID) => {
        return isHoveringData.value[id];
    };
    onUnmounted(() => {
        isHoveringData.value = {};
        isHoveringHanlder = {};
    });
    return {
        enter,
        leave,
        isHovering,
    };
}
export { useHovering };
